import { kindTranslationKey, periodsOfValve, splitDuration } from '../utils'

describe('splitDuration', () => {
  it('splits seconds into hours and minutes', () => {
    expect(splitDuration(2 * 3600 + 5 * 60)).toEqual({ hours: 2, minutes: 5 })
  })

  it('rounds to whole minutes', () => {
    expect(splitDuration(89)).toEqual({ hours: 0, minutes: 1 })
    expect(splitDuration(3599)).toEqual({ hours: 1, minutes: 0 })
  })

  it('handles missing values', () => {
    expect(splitDuration(undefined)).toEqual({ hours: 0, minutes: 0 })
  })
})

describe('kindTranslationKey', () => {
  it('returns the map translation of the failure', () => {
    expect(kindTranslationKey('open_failed')).toEqual('map:valveFailure.open')
    expect(kindTranslationKey('close_failed')).toEqual('map:valveFailure.close')
  })
})

describe('periodsOfValve', () => {
  it('returns only the periods of the valve, newest first', () => {
    const periods = [
      { id: 1, valveId: 7, startedAt: '2026-09-18T08:00:00.000+02:00' },
      { id: 2, valveId: 8, startedAt: '2026-09-19T08:00:00.000+02:00' },
      { id: 3, valveId: 7, startedAt: '2026-09-19T09:00:00.000+02:00' },
    ]
    expect(periodsOfValve(periods, '7').map(({ id }) => id)).toEqual([3, 1])
  })

  it('returns an empty list without periods', () => {
    expect(periodsOfValve(null, 7)).toEqual([])
  })
})
